export default {"src":"/_next/static/image/public/images/report_timer_progress.9904bbede324fb87d2b6fa9b6f72e08f.svg","height":28,"width":29};